export function boxValidate(box){
    var result = true;

    result = validateId(box.id);
    result = validateName(box.name);
    result = validateLength(box.length);
    result = validateWidth(box.width);
    result = validateHeight(box.height);
    result = validateVolumetricWeight(box.volumetricWeight);
    result = validateUnits(box.units);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateLength(length){
    if(typeof length === 'number' || length == null) return true;
    else return false;
}

function validateWidth(width){
    if(typeof width === 'number' || width == null) return true;
    else return false;
}

function validateHeight(height){
    if(typeof height === 'number' || height == null) return true;
    else return false;
}

function validateVolumetricWeight(volumetricWeight){
    if(typeof volumetricWeight === 'number' || volumetricWeight == null) return true;
    else return false;
}

function validateUnits(units){
    if(typeof units === 'string' && units.trim() !== '') return true;
    else return false;
}